import React from 'react';
import { HERO } from '@/constants/testIds';

const APP_STORE_URL = 'https://apps.apple.com/us/app/copy-click/id6759909676';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.copy.click';
const PUB = process.env.PUBLIC_URL || '';

export const StoreBadges = ({ className = '', size = 'h-[52px]', align = 'responsive' }) => (
  <div className={`flex flex-wrap items-center gap-3 ${align === 'center' ? 'justify-center' : 'justify-center lg:justify-start'} ${className}`}>
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={HERO.appStore}
      aria-label="Download on the App Store"
      className="transition-transform hover:-translate-y-0.5 hover:opacity-90"
    >
      <img src={`${PUB}/appstore-badge.svg`} alt="Download on the App Store" className={`${size} w-auto`} draggable="false" />
    </a>
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={HERO.playStore}
      aria-label="Get it on Google Play"
      className="transition-transform hover:-translate-y-0.5 hover:opacity-90"
    >
      <img src={`${PUB}/googleplay-badge.svg`} alt="Get it on Google Play" className={`${size} w-auto`} draggable="false" />
    </a>
  </div>
);
